/*
 * 秋ヶ瀬CLASSIC チケット一覧のポップアップと購入処理
 * - [data-ak-open] で dialog を開く（data-ak-variant があればその種類を選択）
 * - 必須チェック → 生年月日から大会当日の年齢を計算 → /cart/add.js へ追加
 * - キッズは「同じお子様は1日1レースまで」をカートの中身と照合して止める
 * - 前回入力した値は端末に保存して次回の初期値にする（サーバー側の登録情報がある欄は上書きしない）
 */
(function () {
  'use strict';

  var STORE = 'ak:';
  var yen = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' });

  function load(key) {
    try { return localStorage.getItem(STORE + key) || ''; } catch (e) { return ''; }
  }
  function save(key, val) {
    try { localStorage.setItem(STORE + key, val); } catch (e) { /* 保存できない環境では何もしない */ }
  }

  // 大会当日時点の満年齢
  function ageOn(birth, eventDate) {
    var b = new Date(birth + 'T00:00:00');
    var d = new Date(eventDate + 'T00:00:00');
    if (isNaN(b) || isNaN(d)) return '';
    var age = d.getFullYear() - b.getFullYear();
    var m = d.getMonth() - b.getMonth();
    if (m < 0 || (m === 0 && d.getDate() < b.getDate())) age--;
    return age;
  }

  function setHidden(form, name, value) {
    var el = form.querySelector('input[type=hidden][name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  function updateTotal(form) {
    var total = form.querySelector('[data-ak-total]');
    if (!total) return;
    var qtyEl = form.querySelector('[data-ak-qty]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    total.textContent = yen.format((parseInt(total.dataset.akUnit, 10) / 100) * qty);
  }

  // 枚数ぶんの名前欄を作る（入力済みの値は残す）
  function renderNames(form) {
    var box = form.querySelector('[data-ak-names]');
    var qtyEl = form.querySelector('[data-ak-qty]');
    if (!box || !qtyEl) return;
    var qty = Math.min(10, Math.max(1, parseInt(qtyEl.value, 10) || 1));
    var label = box.dataset.akNameLabel;
    var inputs = box.querySelectorAll('input');
    for (var i = inputs.length; i < qty; i++) {
      var input = document.createElement('input');
      input.type = 'text';
      input.name = 'properties[' + label + (i + 1) + ']';
      input.placeholder = (i + 1) + '人目（例：バイクランド タロウ）';
      input.setAttribute('data-ak-req', '');
      if (i === 0) {
        input.setAttribute('data-ak-remember', 'visitor1');
        input.value = load('visitor1');
      }
      box.appendChild(input);
    }
    for (var j = inputs.length - 1; j >= qty; j--) inputs[j].remove();
    updateTotal(form);
  }

  // マイページで登録した参加者情報（本人＋出走者リスト）
  var people = (function () {
    var el = document.getElementById('ak-profile');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      // JSON メタフィールドは環境によって「JSON文字列」のまま出力されるので、その場合はもう一度読む
      if (typeof data.profile === 'string') data.profile = JSON.parse(data.profile || '{}');
      data.profile = data.profile || {};
      data.profile.participants = data.profile.participants || [];
      return data;
    } catch (e) { return null; }
  })();

  // 「出走する方」の選択に合わせて入力欄を埋める（その他は空欄にして手入力）
  function fillRunner(form) {
    var select = form.querySelector('[data-ak-runner]');
    if (!select || !people) return;
    var p = people.profile;
    var person = {};
    if (select.value === 'self') {
      person = { name: people.name, kana: p.kana, nickname: p.nickname, birthdate: p.birthdate, gender: p.gender, team: p.team };
    } else if (select.value !== 'other') {
      person = p.participants[parseInt(select.value, 10)] || {};
    }
    var map = { '出走者名': 'name', 'よみがな': 'kana', 'ニックネーム': 'nickname', '生年月日': 'birthdate', '性別': 'gender', 'チーム名': 'team' };
    Object.keys(map).forEach(function (label) {
      var el = form.querySelector('[name="properties[' + label + ']"]');
      if (el) el.value = person[map[label]] || '';
    });
    toggleRunnerFields(form);
  }

  // ご本人のときは登録内容の要約だけ出し、お子様・他の方を選んだときだけ入力欄を開く
  function toggleRunnerFields(form) {
    var select = form.querySelector('[data-ak-runner]');
    var fields = form.querySelector('[data-ak-runner-fields]');
    var summary = form.querySelector('[data-ak-runner-summary]');
    if (!select || !fields) return;
    var self = select.value === 'self';
    fields.hidden = self;
    if (!summary) return;
    summary.hidden = !self;
    if (self) {
      var v = function (label) {
        var el = form.querySelector('[name="properties[' + label + ']"]');
        return el ? el.value : '';
      };
      var birth = v('生年月日');
      summary.textContent = [
        v('出走者名') + (v('よみがな') ? '（' + v('よみがな') + '）' : ''),
        v('ニックネーム') && 'ニックネーム：' + v('ニックネーム'),
        birth && birth.replace(/^(\d+)-0?(\d+)-0?(\d+)$/, '$1年$2月$3日生まれ'),
        v('チーム名') && 'チーム：' + v('チーム名')
      ].filter(Boolean).join('　');
    }
  }

  function prefill(form) {
    form.querySelectorAll('[data-ak-remember]').forEach(function (el) {
      if (!el.value) el.value = load(el.dataset.akRemember);
    });
  }

  function remember(form) {
    form.querySelectorAll('[data-ak-remember]').forEach(function (el) {
      if (el.value) save(el.dataset.akRemember, el.value);
    });
  }

  function showAlert(form, msg) {
    var a = form.querySelector('[data-ak-alert]');
    a.textContent = msg;
    a.hidden = !msg;
  }

  function validate(form) {
    var bad = [];
    form.querySelectorAll('[data-ak-req]').forEach(function (el) {
      var empty = el.type === 'checkbox' ? !el.checked : !String(el.value).trim();
      el.classList.toggle('ak-err', empty);
      if (empty) bad.push(el);
    });
    if (bad.length) {
      // 折り畳んだ欄に未入力があれば開いて見せる
      var fields = form.querySelector('[data-ak-runner-fields]');
      if (fields && fields.hidden && bad.some(function (el) { return fields.contains(el); })) fields.hidden = false;
      showAlert(form, '必須項目が ' + bad.length + ' 件未入力です。');
      bad[0].focus();
      return false;
    }
    return true;
  }

  // キッズ：同じお子様・同じ日のキッズ枠がカートにあれば止める
  function checkKidsRule(form, cart) {
    if (form.dataset.akKind !== 'kids') return '';
    var name = (form.querySelector('[name="properties[出走者名]"]').value || '').replace(/\s/g, '');
    var day = form.querySelector('[name="properties[_day]"]').value;
    var dup = cart.items.some(function (item) {
      var p = item.properties || {};
      return p._kind === 'kids' && p._day === day && String(p['出走者名'] || '').replace(/\s/g, '') === name;
    });
    return dup ? 'キッズのレースは、お一人1日1レースまでです。同じお子様の同じ日のエントリーがすでにカートにあります。' : '';
  }

  // ===== エントリー内容のチェック（A：二重エントリー / B：年齢・学年 / C：よみがな） =====

  function norm(s) { return String(s || '').replace(/[\s　]/g, ''); }
  function field(form, label) {
    var el = form.querySelector('[name="properties[' + label + ']"]');
    return el ? el.value : '';
  }

  // 大会のある2026年度の学年。未就学は0以下、中学1年は7、高校生以上は13以上
  var SCHOOL_YEAR = 2026;
  function schoolGrade(birth) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birth || '');
    if (!m) return null;
    var y = +m[1], md = +m[2] * 100 + +m[3];
    // 4月1日生まれまでは前年度の学年に入る
    if (md <= 401) y -= 1;
    return SCHOOL_YEAR - y - 6;
  }
  function gradeLabel(g) {
    if (g <= 0) return '未就学';
    if (g <= 6) return '小学' + g + '年生';
    if (g <= 9) return '中学' + (g - 6) + '年生';
    return '高校生以上';
  }

  // 商品ごとの対象。age は大会当日の年齢、grade は学年（中学生以上＝7〜）
  var JR_HIGH = { minGrade: 7, label: '中学生以上' };
  var RULES = {
    'kidslore-a-24': { minAge: 2, maxAge: 4, maxGrade: 0, label: '2〜4歳の未就学のお子様' },
    'kidslore-b-24': { minAge: 2, maxAge: 4, maxGrade: 0, label: '2〜4歳の未就学のお子様' },
    'kidslore-c-24': { minAge: 2, maxAge: 4, maxGrade: 0, label: '2〜4歳の未就学のお子様' },
    'kidslore-d-24': { minAge: 2, maxAge: 4, maxGrade: 0, label: '2〜4歳の未就学のお子様' },
    'kidslore-a-56': { minAge: 5, maxAge: 6, maxGrade: 0, label: '5〜6歳の未就学のお子様', hint: '小学生はジュニアクラスへ' },
    'kidslore-b-56': { minAge: 5, maxAge: 6, maxGrade: 0, label: '5〜6歳の未就学のお子様', hint: '小学生はジュニアクラスへ' },
    'kidslore-c-56': { minAge: 5, maxAge: 6, maxGrade: 0, label: '5〜6歳の未就学のお子様', hint: '小学生はジュニアクラスへ' },
    'kidslore-d-56': { minAge: 5, maxAge: 6, maxGrade: 0, label: '5〜6歳の未就学のお子様', hint: '小学生はジュニアクラスへ' },
    'junior-class': { minGrade: 1, maxGrade: 3, label: '小学1〜3年生' },
    'high-junior-class': { minGrade: 4, maxGrade: 6, label: '小学4〜6年生' },
    'owl-class-kids': { maxGrade: 6, label: '小学生以下' },
    'owl-class': { minGrade: 7, label: '中学生以上', hint: '小学生以下の方は「オウルクラス（キッズ〜ハイジュニア特別料金）」からお申し込みください' },
    'wanchan-cross-bikejoring': { minGrade: 4, label: '小学校高学年以上' },
    'wanchan-cross-canicross': { minGrade: 4, label: '小学校高学年以上' },
    'team-rally-friend': JR_HIGH,
    'virgin-class': JR_HIGH, 'time-travelers-race': JR_HIGH, 'small-wheels-big-race': JR_HIGH,
    'rc-car-grand-prix': JR_HIGH, 'cargo-bike-race': JR_HIGH, 'fun-class-a': JR_HIGH,
    'track-smokin-cross': JR_HIGH, 'sunset-rally-team': JR_HIGH, 'sunset-rally-solo': JR_HIGH,
    'fast-class': JR_HIGH, 'fun-class-b': JR_HIGH, 'girls-power-race': JR_HIGH
  };
  // ワンショットはクラスで対象が変わる
  var ONE_SHOT = {
    '小学生クラス': { minGrade: 1, maxGrade: 6, label: '小学生' },
    '中学生クラス': { minGrade: 7, maxGrade: 9, label: '中学生' }
  };

  function checkEligibility(form) {
    var birth = field(form, '生年月日');
    if (!birth) return '';
    var handle = form.dataset.akHandle;
    var rule = RULES[handle];
    if (handle === 'one-shot-race') rule = ONE_SHOT[field(form, 'クラス')] || { minGrade: 1, label: '小学生以上' };
    if (!rule) return '';
    var age = ageOn(birth, form.dataset.akEventDate);
    var g = schoolGrade(birth);
    var bad = (rule.minAge != null && age < rule.minAge) || (rule.maxAge != null && age > rule.maxAge) ||
      (rule.minGrade != null && g < rule.minGrade) || (rule.maxGrade != null && g > rule.maxGrade);
    if (!bad) return '';
    return 'このレースは' + rule.label + 'が対象です。入力された生年月日では、大会当日' + age + '歳（' + gradeLabel(g) + '）になります。' +
      (rule.hint ? rule.hint + '。' : '') + '生年月日かエントリーするレースをご確認ください。';
  }

  // よみがなは ひらがな・カタカナ・長音・空白だけ
  function checkKana(form) {
    var v = field(form, 'よみがな');
    if (!v) return '';
    return /^[ぁ-ゟ゠-ヿｦ-ﾟ\s　・]+$/.test(v) ? '' :
      'よみがなは ひらがな または カタカナ で入力してください（姓と名の両方）。';
  }

  // 駐車券（キャンプ駐車券も含む）の運転される方のお名前は、当日の照合のためカタカナだけにする
  function checkParkingKana(form) {
    var box = form.querySelector('[data-ak-names]');
    if (!box || box.dataset.akNameLabel !== '車') return '';
    var bad = [].filter.call(box.querySelectorAll('input'), function (el) {
      return el.value.trim() && !/^[゠-ヿｦ-ﾟ\s　]+$/.test(el.value.trim());
    });
    if (!bad.length) return '';
    bad.forEach(function (el) { el.classList.add('ak-err'); });
    bad[0].focus();
    return '運転される方のお名前は、カタカナで入力してください（例：バイクランド タロウ）。';
  }

  // 同じ出走者が同じレースに、カート内または過去の注文ですでにエントリーしていれば止める
  var entered = (function () {
    var el = document.getElementById('ak-entered');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  })();
  function checkDuplicate(form, cart) {
    var name = norm(field(form, '出走者名'));
    if (!name) return '';
    var pid = Number(form.dataset.akProduct);
    var inCart = cart.items.some(function (item) {
      return item.product_id === pid && norm((item.properties || {})['出走者名']) === name;
    });
    if (inCart) return 'この方のこのレースへのエントリーは、すでにカートに入っています。';
    var past = entered.filter(function (e) { return Number(e.p) === pid && norm(e.n) === name; })[0];
    return past ? 'この方はこのレースにエントリー済みです（注文 ' + past.o + '）。' : '';
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-ak-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function submit(form) {
    showAlert(form, '');
    if (!validate(form)) return;

    var birth = form.querySelector('[data-ak-birth]');
    if (birth && birth.value) {
      setHidden(form, 'properties[年齢（大会当日）]', ageOn(birth.value, form.dataset.akEventDate));
    }

    var pre = checkKana(form) || checkParkingKana(form) || checkEligibility(form);
    if (pre) {
      showAlert(form, pre);
      return;
    }

    // 送信直前にも、画面の種類と送信する種類（hidden の id）をそろえる
    var variantSelect = form.querySelector('[data-ak-variant-select]');
    if (variantSelect) form.querySelector('input[name=id]').value = variantSelect.value;

    var btn = form.querySelector('.ak-btn--add');
    btn.disabled = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var err = checkKidsRule(form, cart) || checkDuplicate(form, cart);
        if (err) throw new Error(err);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
      })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'カートに入れられませんでした。');
          return data;
        });
      })
      .then(function () {
        remember(form);
        form.querySelector('[data-ak-done]').hidden = false;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(updateCartCount)
      .catch(function (e) { showAlert(form, e.message); })
      .finally(function () { btn.disabled = false; });
  }

  function openDialog(id, variantId) {
    var dlg = document.getElementById(id);
    if (!dlg) return;
    var form = dlg.querySelector('[data-ak-form]');
    if (form) {
      form.querySelector('[data-ak-done]').hidden = true;
      showAlert(form, '');
      var select = form.querySelector('[data-ak-variant-select]');
      if (select) {
        if (variantId) select.value = variantId;
        // 送信する種類（hidden の id）を、画面に見えている種類に必ず合わせる。
        // change はページ全体で受けているので bubbles を付ける（付けないと 11/21 のまま残る）
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      fillRunner(form);
      prefill(form);
      renderNames(form);
    }
    dlg.showModal();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ak-open]');
    if (opener) {
      openDialog(opener.dataset.akOpen, opener.dataset.akVariant);
      return;
    }
    if (e.target.closest('[data-ak-close]')) {
      e.target.closest('dialog').close();
      return;
    }
    // 背景（dialog 自体）のクリックで閉じる
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-ak-form]');
    if (!form) return;
    if (e.target.matches('[data-ak-runner]')) fillRunner(form);
    if (e.target.matches('[data-ak-variant-select]')) {
      var opt = e.target.selectedOptions[0];
      form.querySelector('input[name=id]').value = e.target.value;
      var total = form.querySelector('[data-ak-total]');
      if (total && opt) total.dataset.akUnit = opt.dataset.price;
      updateTotal(form);
    }
  });

  document.addEventListener('input', function (e) {
    var form = e.target.closest('[data-ak-form]');
    if (!form) return;
    if (e.target.matches('[data-ak-qty]')) renderNames(form);
    if (e.target.classList.contains('ak-err')) e.target.classList.remove('ak-err');
  });

  // 商品ページ（/products/…）から来たときは、その商品のポップアップを最初から開く
  var openOnLoad = document.querySelector('[data-ak-open-on-load]');
  if (openOnLoad) openDialog(openOnLoad.dataset.akOpenOnLoad);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ak-form]');
    if (!form) return;
    e.preventDefault();
    submit(form);
  });
})();
